import styled from "styled-components";

export const TextAreaMessage = styled.textarea`
    width: 100%;
    font-family: var(--FinanceTextAreaMessageFont-family);
    border-radius: 4px;
    height: 100px;
    padding: 12px 20px;
    background-color: rgb(243, 246, 249);
    border: none;
    resize: none;
    color:#002E5C;
`
